import React from "react";
import PropTypes from "prop-types";
import { Link as MuiLink } from "@mui/material";

import Card from "../../../Card";
import TruncatedWithTooltip from "../../../TruncatedWithTooltip";
import CompanyOverviewField from "../shared/CompanyOverviewField";
import { useSelector } from "react-redux";
import messages from "../../../../assets/locale/messages";

const CompanyInfoCard = ({ company }) => {
  const lang = useSelector((state) => state.locale.lang);
  const { registrationReq: t } = messages[lang];

  if (!company) return null;

  const city =
    lang === "ar"
      ? company.city?.name_ar || company.city?.name_en
      : company.city?.name_en || company.city?.name_ar;

  return (
    <Card
      title={t.companyInformation}
      classNames={{ body: "company-overview-card__body" }}
    >
      <div className="company-overview-field-grid company-overview-field-grid--cols-2">
        <CompanyOverviewField label={t.englishName}>
          <TruncatedWithTooltip title={company.name_en || "—"} lines={2}>
            <span>{company.name_en || "—"}</span>
          </TruncatedWithTooltip>
        </CompanyOverviewField>
        <CompanyOverviewField label={t.arabicName}>
          <TruncatedWithTooltip title={company.name_ar || "—"} lines={2}>
            <span>{company.name_ar || "—"}</span>
          </TruncatedWithTooltip>
        </CompanyOverviewField>
        <CompanyOverviewField label={t.city} value={city || "—"} />
        <CompanyOverviewField label={t.commercialRecord}>
          {company.commercial_record_url ? (
            <MuiLink
              href={company.commercial_record_url}
              target="_blank"
              rel="noopener noreferrer"
              underline="hover"
            >
              {company.commercial_record || "—"}
            </MuiLink>
          ) : (
            company.commercial_record || "—"
          )}
        </CompanyOverviewField>
      </div>
    </Card>
  );
};

CompanyInfoCard.propTypes = {
  company: PropTypes.object,
};

CompanyInfoCard.defaultProps = {
  company: null,
};

export default CompanyInfoCard;
